export default __webpack_public_path__ + "static/media/kb_bannre.21157338.png";